import React from "react"
import { RouteComponentProps } from "@reach/router"
import { IFrame } from "../../integration/iframe"

export const Referrals: React.FC<RouteComponentProps> = () => (
  <>
    <IFrame path="referrals" />
  </>
)
